/**
 * Compara dois valores primitivos e verifica se são iguais.
 *
 * @param valueOne - O primeiro valor a ser comparado.
 * @param valueTwo - O segundo valor a ser comparado.
 * @returns `true` se os valores forem iguais, caso contrário, `false`.
 */

export const isCompareEqualsValues = (
  valueOne: string | undefined,
  valueTwo: string | undefined
): boolean => {
  if (!valueOne || !valueTwo) {
    return false;
  }

  return valueOne === valueTwo;
};
